import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { getPosters } from '../../Store/posters/postersSlice';
import styles from '../../styles/HomePage.module.scss';
import BG from '../../images/shlifmashina.png';
import { posterUrl } from '../../utils/imageUrl';
import CarouselNav from '../common/CarouselNav';
import ProductImage from '../common/ProductImage';
import { getProductUrl } from '../../utils/urls';

const PosterSlide = ({ poster, onButtonClick, isLcp = false }) => {
  const title = poster.title;
  const subtitle = poster.subtitle;
  const heading = poster.heading;
  const buttonText = poster.buttonText;
  const initialImageUrl = useMemo(
    () => ((poster.image && typeof poster.image === 'string') ? posterUrl(poster.image) : BG),
    [poster.image]
  );
  const [imageUrl, setImageUrl] = useState(initialImageUrl);

  useEffect(() => {
    setImageUrl(initialImageUrl);
  }, [initialImageUrl]);

  return (
    <div className={styles.home}>
      <div className={styles.title}>{title}</div>
      <div className={styles.product}>
        <div className={styles.text}>
          <div className={styles.subtitle}>{subtitle}</div>
          <div className={styles.head} role="heading" aria-level="2">{heading}</div>
          <button
            type="button"
            className={styles.button}
            onClick={() => onButtonClick(poster)}
          >
            {buttonText}
          </button>
        </div>
        <div className={styles.image}>
          <ProductImage
            src={imageUrl}
            alt={heading || 'Постер'}
            width={400}
            height={300}
            loading={isLcp ? 'eager' : 'lazy'}
            fetchPriority={isLcp ? 'high' : undefined}
            onError={() => setImageUrl(BG)}
          />
        </div>
      </div>
    </div>
  );
};

const Poster = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const [slideIndex, setSlideIndex] = useState(0);
  const { list: posters } = useSelector((state) => state.posters);

  useEffect(() => {
    dispatch(getPosters());
  }, [dispatch]);

  const handleButtonClick = (poster) => {
    if (poster.productId) {
      navigate(getProductUrl({ id: poster.productId, slug: poster.productSlug }));
    } else {
      navigate(poster.buttonLink || '/');
    }
  };

  if (!posters || posters.length === 0) {
    return (
      <section className={styles.posterCarousel}>
        <PosterSlide
          poster={{
            title: 'Велика знижка 20%',
            subtitle: 'Розпродаж',
            heading: 'Стрічкова шліфувальна машина APRO SB1100',
            buttonText: 'Купити зараз',
            image: null,
            productId: null,
            buttonLink: '/',
          }}
          onButtonClick={() => navigate('/')}
          isLcp
        />
      </section>
    );
  }

  if (posters.length === 1) {
    return (
      <section className={styles.posterCarousel}>
        <PosterSlide poster={posters[0]} onButtonClick={handleButtonClick} isLcp />
      </section>
    );
  }

  const posterNav = (
    <CarouselNav
      total={posters.length}
      current={slideIndex}
      onPrev={() => sliderRef.current?.slickPrev()}
      onNext={() => sliderRef.current?.slickNext()}
      onDotClick={(index) => sliderRef.current?.slickGoTo(index)}
    />
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    arrows: false,
    pauseOnHover: true,
    beforeChange: (_current, next) => setSlideIndex(next),
  };

  return (
    <section className={styles.posterCarousel}>
      <Slider ref={sliderRef} {...settings}>
        {posters.map((poster, index) => (
          <div key={poster.id} className={styles.slide}>
            <PosterSlide
              poster={poster}
              onButtonClick={handleButtonClick}
              isLcp={index === 0}
            />
          </div>
        ))}
      </Slider>
      {posterNav}
    </section>
  );
};

export default Poster;
